<template>
  <section class="instructional-videos">
    <ModalTagEmailAutomation
      :tagEmailAutomationId="tagEmailAutomationId"
      @load="pagedList"
    >
    </ModalTagEmailAutomation>

    <ModalConfirmAction
      variant='danger'
      refModal='deleteTagEmailAutomation'
      idModal='deleteTagEmailAutomation'
      :loading='loadingDelete'
      :description='descriptionDelete'
      :title='titleDelete'
      @confirmed='deleteTagEmailAutomation'
    ></ModalConfirmAction>

    <ModalConfirmAction
      variant='danger'
      refModal='sendBatchTagEmailAutomation'
      idModal='sendBatchTagEmailAutomation'
      :loading='loadingSendBatch'
      :description='descriptionSendBatch'
      :title='titleSendBatch'
      okText="Enviar"
      @confirmed='sendBatch'
    ></ModalConfirmAction>

    <section class="header d-flex align-items-center justify-content-between">
      <section>
        <p class="m-0 title">
          Listagem completa de todos os e-mails de automação.
        </p>
      </section>

      <section>
        <button
          class="btn-add-tutorial p-1 px-3"
          @click="showModalTagEmailAutomation()"
        >
          <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.66667 0V5.41667C6.66668 5.7274 6.78243 6.02699 6.99135 6.25702C7.20026 6.48704 7.48737 6.631 7.79667 6.66083L7.91667 6.66667H13.3333V15C13.3335 15.4205 13.1747 15.8255 12.8888 16.1338C12.6028 16.4421 12.211 16.631 11.7917 16.6625L11.6667 16.6667H1.66667C1.24619 16.6668 0.841195 16.508 0.532877 16.2221C0.224559 15.9362 0.0357029 15.5443 0.00416685 15.125L8.35567e-08 15V1.66667C-0.000132983 1.24619 0.158672 0.841194 0.444581 0.532877C0.73049 0.224559 1.12237 0.0357028 1.54167 0.00416676L1.66667 0H6.66667ZM6.66667 7.91667C6.46256 7.91669 6.26555 7.99163 6.11302 8.12726C5.96049 8.26289 5.86305 8.44979 5.83917 8.6525L5.83333 8.75V10H4.58333C4.37093 10.0002 4.16664 10.0816 4.01219 10.2274C3.85775 10.3732 3.7648 10.5725 3.75236 10.7845C3.73991 10.9965 3.8089 11.2053 3.94522 11.3682C4.08155 11.5311 4.27492 11.6357 4.48583 11.6608L4.58333 11.6667H5.83333V12.9167C5.83357 13.1291 5.9149 13.3334 6.06071 13.4878C6.20651 13.6423 6.40579 13.7352 6.61783 13.7476C6.82986 13.7601 7.03865 13.6911 7.20153 13.5548C7.3644 13.4185 7.46908 13.2251 7.49417 13.0142L7.5 12.9167V11.6667H8.75C8.9624 11.6664 9.16669 11.5851 9.32114 11.4393C9.47559 11.2935 9.56853 11.0942 9.58098 10.8822C9.59342 10.6701 9.52444 10.4614 9.38811 10.2985C9.25179 10.1356 9.05841 10.0309 8.8475 10.0058L8.75 10H7.5V8.75C7.5 8.52899 7.4122 8.31702 7.25592 8.16074C7.09964 8.00446 6.88768 7.91667 6.66667 7.91667ZM8.33333 0.0358333C8.60282 0.0930414 8.85391 0.216157 9.06417 0.394167L9.16667 0.488333L12.845 4.16667C13.0403 4.36176 13.184 4.60229 13.2633 4.86667L13.2967 5H8.33333V0.0358333Z"
                  fill="#022245" />
          </svg>

          <span class="ml-2">Adicionar e-mail de automação</span>
        </button>
        <button
          class="btn-add-tutorial p-1 px-3 ml-2"
          @click="exportToExcel()"
        >
          <b-icon icon="file-excel-fill"></b-icon>

          <span class="ml-2">Exportar tags</span>
        </button>
      </section>
    </section>

    <section class="mt-3">
      <b-overlay
        :show="loading"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
        class="d-inline-block w-100"
        style="min-height: 100px"
      >
        <table class="w-100 text-center">
          <thead>
          <tr class="thead-tr">
            <th class="py-3 w-25">
              Tags de gatilho
            </th>
            <th class="py-3 w-25">
              Assunto
            </th>
            <th class="py-3 w-25">
              Data do cadastro
            </th>
            <th class="py-3 w-25">
              Opções
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="(tagEmailAutomation, index) in tagEmailAutomations"
            :key="`${tagEmailAutomation._id}_${index}`"
            class="tbody-tr"
            :style="index < tagEmailAutomations.length - 1 ? 'border-bottom: 1px solid #EDEDED;': ''"
          >
            <td class="px-1 py-2">
              {{
                tagEmailAutomation.triggerTag
                  ? triggerTags.find(x => x.tag === tagEmailAutomation.triggerTag).tagDescription
                  : '-'
              }}
            </td>

            <td class="px-1 py-2">
              {{ tagEmailAutomation.emailSubject }}
            </td>

            <td class="px-1 py-2">
              {{ formatDate(tagEmailAutomation.createdAt) }}
            </td>

            <td class="px-1 py-2 videoLink">
              <a
                class="mr-3 cursor-pointer"
                @click="showModalEditTagEmailAutomation(tagEmailAutomation._id)"
              >
                Editar
              </a>
              <a
                class="cursor-pointer"
                @click="showModaldeleteTagEmailAutomation(tagEmailAutomation)"
              >
                Excluir
              </a>

              <a
                v-if="tagEmailAutomation.emails && tagEmailAutomation.emails.length > 0"
                class="cursor-pointer ml-3"
                @click="showModalSendBatch(tagEmailAutomation)"
              >
                Enviar e-mails
              </a>

              <a
                v-if="tagEmailAutomation.emails && tagEmailAutomation.emails.length > 0"
                class="cursor-pointer ml-3"
                @click="goToLogs(tagEmailAutomation)"
              >
                Ver logs
              </a>
            </td>
          </tr>
          </tbody>
        </table>

        <template v-slot:overlay>
          <div class="text-center loading-spinner">
            <b-spinner
              style="width: 3rem; height: 3rem"
              variant="primary"
              label="Large Spinner"
            ></b-spinner>
            <h5 class="text-primary">Buscando...</h5>
          </div>
        </template>

        <section>
          <b-pagination
            v-if='tagEmailAutomationsMeta.total > 10'
            align="center"
            :per-page='10'
            v-model="tagEmailAutomationsMeta.page"
            :total-rows="tagEmailAutomationsMeta.total"
            first-text="⏮"
            prev-text="⏪"
            next-text="⏩"
            last-text="⏭"
            @page-click='setPage'
            size="lg"
            class="mt-3"
          >
          </b-pagination>
        </section>
      </b-overlay>
    </section>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import ModalConfirmAction from '@/components/ModalConfirmAction.vue'
import format from 'date-fns/esm/format/index'
import XLSX from 'xlsx'
import ModalTagEmailAutomation from '@/components/TagEmailAutomation/components/ModalTagEmailAutomation.vue'

export default {
  name: 'TagEmailAutomation',
  components: { ModalTagEmailAutomation, ModalConfirmAction },
  data() {
    return {
      loadingDelete: false,
      descriptionDelete: '',
      titleDelete: '',
      loading: false,
      loadingSendBatch: false,
      titleSendBatch: '',
      descriptionSendBatch: '',
      triggerTags: [],
      tagEmailAutomations: [],
      tagEmailAutomation: Object,
      tagEmailAutomationId: null,
      tagEmailAutomationsMeta: {}
    }
  },
  async mounted() {
    const { items } = await this.handleTagsInstructionalVideos()
    this.triggerTags = items.map((x) => {
      return {
        ...x,
        tagDescription: `${x.description} (${x.tag})`
      }
    })
    await this.pagedList()
  },
  methods: {
    ...mapActions('tagEmailAutomation', {
      handlePagedList: 'handlePagedList',
      handleDelete: 'handleDelete',
      handleSendInBatch: 'handleSendInBatch'
    }),
    ...mapActions('tags', {
      handleTagsInstructionalVideos: 'handleTagsInstructionalVideos'
    }),

    exportToExcel() {
      const data = this.triggerTags.map((x) => {
        return {
          Tag: x.tag,
          ['Descrição']: x.description,
          ['Gatilho/Tarefa/Rotina']: x['Gatilho/Tarefa/Rotina']
        }
      })

      const worksheet = XLSX.utils.json_to_sheet(data)
      const workbook = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(workbook, worksheet, 'Planilha1')
      XLSX.writeFile(workbook, 'tag.xlsx')
    },

    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy HH:mm:ss')
    },

    showModalTagEmailAutomation() {
      this.tagEmailAutomationId = null
      setTimeout(() => {
        this.$bvModal.show('modalTagEmailAutomation')
      }, 100)
    },

    showModalEditTagEmailAutomation(tagEmailAutomationId) {
      this.tagEmailAutomationId = tagEmailAutomationId
      setTimeout(() => {
        this.$bvModal.show('modalTagEmailAutomation')
      }, 100)
    },

    async setPage(event, page) {
      this.tagEmailAutomationsMeta.page = page
      await this.pagedList()
    },

    async pagedList() {
      try {
        this.loading = true
        const { meta, items } = await this.handlePagedList(this.tagEmailAutomationsMeta)
        this.tagEmailAutomations = items
        this.tagEmailAutomationsMeta = meta
        this.loading = false
      } catch (e) {

      }
    },

    showModaldeleteTagEmailAutomation(tagEmailAutomation) {
      this.tagEmailAutomation = tagEmailAutomation
      this.titleDelete = 'Excluir automação de e-mail.'
      this.descriptionDelete = 'Tem certeza de que deseja excluir esta automação de e-mail?<br/><br/><strong>Essa ação não poderá ser desfeita.</strong>'
      this.$bvModal.show('deleteTagEmailAutomation')
    },

    async deleteTagEmailAutomation() {
      try {
        this.loadingDelete = true

        const { data, status, errors } = await this.handleDelete(this.tagEmailAutomation._id)
        let message = errors
        let variant = 'danger'

        if (status === 200 || status === 201) {
          message = data.message
          variant = 'success'
        }

        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        await this.pagedList()
        this.$bvModal.hide('deleteTagEmailAutomation')
        this.loadingDelete = false
      } catch (e) {
        this.loadingDelete = false
      }
    },

    goToLogs(tagEmailAutomation) {
      const { _id } = tagEmailAutomation || {}
      this.$router.push({ name: 'TagEmailAutomationLogs', query: { tagEmailAutomation: _id } })
    },

    showModalSendBatch(tagEmailAutomation) {
      this.tagEmailAutomation = tagEmailAutomation
      this.titleSendBatch = 'Enviar e-mails em lote'
      this.descriptionSendBatch = 'Tem certeza de que deseja enviar o e-mail para todos os e-mails vinculados?<br/><br/><strong>Essa ação não poderá ser desfeita.</strong>'
      this.$bvModal.show('sendBatchTagEmailAutomation')
    },

    async sendBatch() {
      try {
        this.loadingSendBatch = true
        const { _id } = this.tagEmailAutomation || {}
        const { data, status, errors } = await this.handleSendInBatch({ _id })
        let message = errors
        let variant = 'danger'
        const success = status === 200 || status === 201

        if (success) {
          message = data.message
          variant = 'success'
        }

        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.$bvModal.hide('sendBatchTagEmailAutomation')
        this.loadingSendBatch = false

        if (success) {
          this.$router.push({ name: 'TagEmailAutomationLogs', query: { tagEmailAutomation: _id } })
        }
      } catch (e) {
        this.loadingSendBatch = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.instructional-videos {
  .header {
    .title {
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      color: #262626;
    }

    .btn-add-tutorial {
      font-weight: 400;
      font-size: 15px;
      border: 1px solid #AEBBCD;
      border-radius: 6px;
      color: #6D7989;
      background: #FFFFFF;
    }
  }

  .thead-tr {
    background: var(--navy-blue);
    color: #ECF0F3;
    font-weight: 600;
    font-size: 16px;
    text-align: center;
  }

  .tbody-tr {
    background: #FFFFFF;
    font-size: 15px;
    text-align: center;

    color: #808080;
    font-weight: 400;

    .videoLink {
      font-weight: 700;
      color: var(--navy-blue) !important;
      text-decoration: underline;
    }
  }

  .w-20 {
    width: 20% !important
  }

  .w-33 {
    width: 33.33% !important
  }
}

</style>
